import { z } from "zod";
import { Fetcher } from "../../../../fetcher";
import { usTreasuryBondProfileSchema } from "./usTreasuryBondProfile";
import { CognitoIdToken } from "../../../users/authTypes";

const schema = z.array(usTreasuryBondProfileSchema);

export type ApiListUsTreasuryBondOkResponse = z.infer<typeof schema>;

export const listUsTreasuryBondProfile = (fetcher: Fetcher, cognitoIdToken: CognitoIdToken) => {
  return fetcher({
    endpoint: "/traderUi/bonds/usTreasuryBondProfiles/list",
    method: "GET",
    schema,
    cognitoIdToken,
  });
};
